@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/mixins/common" as m;

.bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px 0;
    padding: 16px 24px;
    background-color: v.$palette-white;
    border-radius: 16px;
    box-shadow: v.$shadow2;

    @include m.media(v.$container-tablet) {
        gap: 16px;
    }

    .mainBox {
        flex-grow: 1;

        @include m.media(v.$container-tablet) {
            flex-grow: 0;
        }
    }

    // Beats Button tertiary/secondary hover, which paints the icon blue.
    button.actionButton:hover {
        color: v.$palette-orange-2;
        background-color: v.$palette-orange-4;

        svg path {
            fill: v.$palette-orange-2;
        }
    }
}

.hiddenInput {
    display: none;
}

.tooltipContent {
    width: 320px;
}
